var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "trbo-a-multiple-input",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _vm._l(_vm.questionData.inputs, function (input, index) {
        return _c("input-item", {
          key: index,
          attrs: { input: input },
          model: {
            value: _vm.values[index],
            callback: function ($$v) {
              _vm.$set(_vm.values, index, $$v)
            },
            expression: "values[index]",
          },
        })
      }),
      _vm._v(" "),
      _c("div", { staticClass: "trbo-a-multiple-input__actions" }, [
        _c(
          "button",
          {
            staticClass: "trbo-a-multiple-input__button",
            attrs: { type: "submit" },
          },
          [_vm._v(_vm._s(_vm.questionData.inputButtonTitle))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }